// Meta ad message-match architecture: each angle swaps ONLY the opening
// hero message. To launch an ad-angle variant later, render the lander with
// a different `angle` prop on its own route — the body stays identical.
export const LANDER_ANGLES = {
  "long-shift": {
    headline: ["Shifts are hard.", "Your shoes shouldn't be."],
    sub: "Meet POSSO — the colourful work clog built for long days on your feet.",
  },
  colour: {
    headline: ["Work shoes just got", "a lot less boring."],
    sub: "POSSO is the work clog built for long days on your feet — in colours you actually want to wear.",
  },
  spill: {
    headline: ["Because work", "gets messy."],
    sub: "POSSO's closed upper and easy-clean build are made for the spills.",
  },
  grip: {
    headline: ["Made for the floors", "you actually work on."],
    sub: "POSSO's slip-resistant grip is built for wet, unpredictable workplace floors.",
  },
};

export const HERO_BENEFITS = "SLIP-RESISTANT • CLOSED TOE • EASY CLEAN";
